import _objectWithoutProperties from '@babel/runtime/helpers/esm/objectWithoutProperties';
import React from 'react';
import { components } from 'react-select';

function ValueContainer(_ref) {
  var children = _ref.children,
      rest = _objectWithoutProperties(_ref, ["children"]);

  return /*#__PURE__*/React.createElement("div", {
    className: "combobox-value-container"
  }, /*#__PURE__*/React.createElement(components.ValueContainer, rest, children));
}

export default ValueContainer;
export { ValueContainer };
//# sourceMappingURL=ValueContainer.js.map
